import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { CommonMessageService } from 'src/app/services/common-message.service';
import { CommonService } from 'src/app/services/common.service';
import { UserService } from 'src/app/services/user.service';
import { Utils } from 'src/app/utils';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
})
export class ChangePasswordComponent implements OnInit {
  form: FormGroup;
  @Input() dismissible: {value: boolean};
  constructor(
    private formBuilder: FormBuilder,
    private modalController: ModalController,
    private commonService: CommonService,
    private translator: TranslateService,
    private helper: CommonMessageService,
    private userService: UserService
  ) { }
  async save() {
    const data = this.form.value;
    if (data.password && data.password !== data.confirmPassword) {
      this.helper.errorToast(this.translator.instant('MESSAGES.PASSWORDS_NO_MATCH'));
      return;
    }
    const loading = await this.helper.pleaseWaitLoading();
    try {
      await this.commonService.updateUserPassword(this.userService.currentUser.id, data).toPromise();
      this.translator.instant('MESSAGES.UPDATED_SUCCESSFULLY');
      this.dismiss();
      window.location.reload();
    } catch (error) {
      const data = Utils.parseKeyValuesString(error);
      const toast = await this.helper.errorToast(data.code ? this.translator.instant(`MESSAGES.${data.code}`, {
        X: data?.message
      }) : error);
      //this.helper.errorToast('Error:' + this.translator.instant(error));
    } finally {
      loading.dismiss();
    }
  }
  dismiss() {
    this.dismissible.value = true;
    this.modalController.dismiss();
  }
  ngOnInit() {
    this.form = this.formBuilder.group({
      'password': ['', [Validators.required, Validators.minLength(12), Validators.maxLength(80), Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&-])[A-Za-z\d@$!%*?&-]{12,80}$/)]],
      'confirmPassword': ['', [Validators.required, Validators.minLength(12), Validators.maxLength(80)]],
      'updateToken': [this.userService.currentUser.resetToken, [Validators.required]]
    });
  }

}
